import { useAuth } from "@babackapp/auth-client/hooks";
import type {
	ReturnRequestDto,
	ShopDto,
} from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { OctagonAlert } from "lucide-react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { isReturnRequestApproved } from "@/pages/(app)/returns/utils/is-return-request-approved";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";

export function useOpenCarrierClaimAction() {
	const { data: shop } = useCurrentShopSuspense();
	const returnRequest = useCurrentReturnRequest();
	const auth = useAuth();
	const t = useTranslation();

	const generateAirtableUrl = (
		returnRequest: ReturnRequestDto,
		shop: ShopDto,
	) => {
		const baseUrl =
			"https://airtable.com/appXRhhvdy7hwn00G/pagc55vfl5aITm4ER/form";
		const params = new URLSearchParams({
			"prefill_Boutique concernée": shop.name,
			"prefill_Mail de contact": auth.user?.emails[0].address ?? "",
			"prefill_Numéro de la commande concernée": returnRequest.orderName,
			"prefill_Numéro de tracking du colis":
				returnRequest.shipping_info?.tracking_code ?? "",
		});
		return `${baseUrl}?${params.toString()}`;
	};

	// `tracking_code` is optional, so `!== null` also let an absent one through
	// and offered a claim on a parcel that was never shipped (BAB-3194).
	const isChronoShop2Shop =
		returnRequest.shipping_info?.carrier === "chrono-shop2shop" &&
		Boolean(returnRequest.shipping_info?.tracking_code);

	const isApproved = isReturnRequestApproved(returnRequest.status);
	const isCancelled = returnRequest.status.cancelled.done;

	return {
		label: t("returnDetail.openCarrierClaim"),
		icon: <OctagonAlert className="size-4 text-gray-400" />,
		enabled: isApproved && isChronoShop2Shop && !isCancelled,
		onClick: () => {
			const url = generateAirtableUrl(returnRequest, shop);
			window.open(url, "_blank");
		},
		loading: false,
	};
}
